import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Dropdown } from 'primeng/dropdown';
import { MultiSelect } from 'primeng/multiselect';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// On touch devices, opening a filtered select must not auto-focus its search
// input - the focus pops the software keyboard over the panel even though the
// arranger usually just taps an option. PrimeNG 12's autofocusFilter defaults
// to true per-instance (assigned in each constructor), and filtered selects are
// spread across dozens of templates, so the default is overridden once here at
// the prototype: a get/set pair that reports false on touch devices and passes
// through everywhere else. Desktop keeps the autofocus - there the filter
// focus is pure convenience for typists, with no keyboard to pop.
if (window.matchMedia?.('(pointer: coarse)').matches) {
  for (const proto of [Dropdown.prototype, MultiSelect.prototype]) {
    Object.defineProperty(proto, 'autofocusFilter', {
      get: () => false,
      set: () => {
        // Constructor and template bindings still assign it; discard - touch
        // devices never want the keyboard on select-open.
      },
      configurable: true,
    });
  }
}

platformBrowserDynamic()
  // Event coalescing: a single iPad tap fires touchstart/touchend/mousedown/
  // mouseup/focus/click, and zone.js runs a FULL change-detection pass for
  // each - six passes over the whole arrangement form per tap, the bulk of the
  // ~1s tap latency measured on device (2026-09-03). Event coalescing batches
  // the event-triggered passes into one per animation frame, and its rAF only
  // ever starts AFTER a user event, when Safari's rendering pipeline is awake.
  //
  // ngZoneRunCoalescing must NOT be added here. It routes EVERY post-bootstrap
  // change-detection tick through a one-shot native requestAnimationFrame with
  // no fallback, and iPad Safari withholds rAF in several load-adjacent states
  // - which wedged ~20% of reloads at a blank page (only the boot loader hide
  // and the fixed GST button painted) until the first touch forced a frame
  // (angular/angular#44314, present in this exact Angular version). It ALSO
  // silently force-disables ngZoneEventCoalescing (core.js
  // shouldCoalesceEventChangeDetection = !runCoalescing && eventCoalescing),
  // so while it was set the flag below was dead code.
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));
